import React from 'react';
import { useOrganizerBasicInfo } from '../../../../contexts/OrganizerContext';
import { Link } from '../../../_shared/Link/Link';

import styles from './OrganizerLink.module.scss';

export const OrganizerLink = ({ children }: { children: React.ReactNode }) => {
    const { url } = useOrganizerBasicInfo();
    return (
        <Link href={url} className={styles.OrganizerLink}>
            {children}
        </Link>
    );
};
